import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LgpdChave, LgpdService } from '../../../core/services/lgpd.service';
import { sobreRichHtml } from '../../../core/utils/sobre-rich-text.util';

@Component({
  selector: 'app-legal-document',
  templateUrl: './legal-document.component.html',
  styleUrls: ['./legal-document.component.scss'],
  standalone: false,
})
export class LegalDocumentComponent implements OnInit {
  breadCrumbItems: Array<{ label: string; link?: string; active?: boolean }> = [];
  tituloKey = 'legal.termosTitulo';
  conteudoHtml: SafeHtml = '';
  carregando = true;
  erro: string | null = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly lgpd: LgpdService,
    private readonly sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    const chave = (this.route.snapshot.data['lgpdChave'] as LgpdChave) || 'termos';
    this.tituloKey = chave === 'privacidade' ? 'legal.privacidadeTitulo' : 'legal.termosTitulo';
    this.breadCrumbItems = [
      { label: 'common.home', link: '/' },
      { label: this.tituloKey, active: true },
    ];

    if (document.documentElement.scrollTop > 40) {
      document.querySelector('.navbar')?.classList.add('navbar-stuck');
    }

    this.lgpd.pagina(chave).subscribe({
      next: (res) => {
        this.conteudoHtml = this.sanitizer.bypassSecurityTrustHtml(sobreRichHtml(res.conteudo));
        this.carregando = false;
      },
      error: () => {
        this.erro = 'legal.loadError';
        this.carregando = false;
      },
    });
  }
}
